$(document).ready(function () {
    if($('#calendlyForm').length) {
        irisValidation($('#calendlyForm'), {
            url: '/wp/wp-admin/admin-ajax.php?action=calendly_submission',
            filters: {
                phone: 'phoneMask',
            },
            phoneInputName: 'phone',
            validators: {
                firstname: 'firstName',
                lastname: 'lastName',
                email: 'email',
                phone: 'phone',
                company: 'companyName',
            },
            validateByTimeout: ['email'],
            errorMessages: {
                required: 'Please fill out this field.',
                firstNameLong: 'First Name is too long',
                firstNameFormat: 'Not a valid First Name',
                lastNameLong: 'Last Name is too long',
                lastNameFormat: 'Not a valid Last Name',
                emailFormat: 'Not a valid email',
                phoneFormat: 'Please use only US numbers',
                companyNameLong: 'Company Name is too long',
                companyNameFormat: 'Company Name has invalid format',
                connectionError: 'Server connection error. Please try again later.', // Text of error when we have some connection errors
            },
            success: function (data) {
                calendly_frame(data.calendlyUrl, data.prefillData);
            }
        });
    }
});

function calendly_frame(url, prefill) {
    $('#calendlyFormContainer').html('').addClass('fixHeight');
    Calendly.initInlineWidget({
        url: url,
        parentElement: document.getElementById('calendlyFormContainer'),
        prefill: prefill,
    });
    window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
    });
}